// extracted by mini-css-extract-plugin
export default {"root":"recipes-sidebar_root__sx2qk","sidebarExpanded":"recipes-sidebar_sidebarExpanded__XDxbN","warehousesList":"recipes-sidebar_warehousesList__GT2ns"};